//@flow
import React, { useState, useMemo } from "react";
import { getDisplayName } from "data/constants";
import { ModalCloseContext } from "data/context";

export const withModalCloseHandlerConsumer = (
    WrappedComponent: ComponentType<any>
) => {
    const HOC = (props: Props) => {
        return (
            <ModalCloseContext.Consumer>
                {(context) => (
                    <WrappedComponent
                        closeHandler={context?.closeHandler}
                        setCloseHandler={context?.setCloseHandler}
                        {...props}
                    />
                )}
            </ModalCloseContext.Consumer>
        );
    };
    HOC.displayName = `withModalCloseHandlerConsumer(${getDisplayName(
        WrappedComponent
    )})`;
    return HOC;
};

export const withModalCloseHandler = (WrappedComponent: ComponentType<any>) => {
    const HOC = (props: Props) => {
        const [closeHandler, setCloseHandler] = useState(null);

        const context = useMemo(
            () => ({
                closeHandler,
                setCloseHandler,
            }),
            [closeHandler, setCloseHandler]
        );

        return (
            <ModalCloseContext.Provider value={context}>
                <WrappedComponent {...props} />
            </ModalCloseContext.Provider>
        );
    };
    HOC.displayName = `withModalCloseHandler(${getDisplayName(
        WrappedComponent
    )})`;
    return HOC;
};
